import {connect} from '../../redux/utils'
import {selectFeatures} from '../../features/selectors'
import {bindActionCreators} from 'redux'
import {FeatureDiffController} from '../../features/components/FeatureDiffController'
import {Feature} from '../../features'
import {handleFeatureChange} from '../common/actions'

class PageFeatureDiffController extends FeatureDiffController {
    constructor({
        handleFeatureChange = () => {},
    }) {
        super({
            handledFeatures: [Feature.TWS, Feature.BTY, Feature.EST, Feature.WAS],
            onFeaturesChanged: handleFeatureChange,
        })
    }
}

export default connect(
    state => ({
        features: selectFeatures(state),
    }),
    dispatch => ({
        handleFeatureChange: bindActionCreators(handleFeatureChange, dispatch),
    })
)(PageFeatureDiffController)



// WEBPACK FOOTER //
// ./web/js/taskManagement/components/PageFeatureDiffController.js